import { render } from "./GeneralStatistics.vue?vue&type=template&id=e01d2b56&scoped=true&ts=true"
import script from "./GeneralStatistics.vue?vue&type=script&lang=ts"
export * from "./GeneralStatistics.vue?vue&type=script&lang=ts"

import "./GeneralStatistics.vue?vue&type=style&index=0&id=e01d2b56&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01d2b56"]])

export default __exports__